import ApiClient from '../../API/api';
import type {ProductPrices} from '../models/ProductPrice';
import type {ProductDetails} from '../../product/models/ProductDetails';
import type {ApiResponse} from '../../helpers/models/Response';
import type {Filters} from '../models/Filters';

const CATALOG_ENDPOINT = 'product';
const PRODUCTS_PRICES_ENDPOINT = 'product/prices';

const parseProductPrices = (response): ProductPrices => {
    return response.reduce((acc, it) => {
        acc[it.producto_codigo] = {
            basePrice: it.precio_old,
            sellingPrice: it.pro_precio
        };
        return acc;
    }, {});
};

// TODO: deprecated. This should be moved to the CatalogApi
export default class CatalogService {

    static getProducts = (filters: Filters, config: {
        page: number,
        amount: number
    }): Promise<ApiResponse<ProductDetails[]>> => {
        return ApiClient.performRequest(
            CATALOG_ENDPOINT,
            {
                method: 'POST',
                queryParams: {page: config.page, products_per_page: config.amount},
                body: {
                    busqueda: filters?.search || '',
                    prescripcion: filters?.vetPrescription,
                    pro_especie: filters?.species || [],
                    pro_laboratorio: filters?.manufacturers || [],
                    pro_macrofamilia: filters?.macroFamily || '',
                    pro_familia: filters?.family || '',
                    pro_subfamilia: filters?.subFamilies || [],
                    destacado: filters?.featured || null,
                    pro_precio_min: 0,
                    pro_precio_max: 0,
                    pro_caracteristica: [],
                }
            }
        );
    };

    static getPrices = (productCodes: string[]): Promise<ProductPrices> => {
        return ApiClient.performRequest(
            PRODUCTS_PRICES_ENDPOINT,
            {
                method: 'POST',
                body: productCodes
            }
        ).then(parseProductPrices);
    };
}
